/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Equipment\CreateEquipment.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday March 26th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 26th 2024 11:38:38 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { UpdateCarType } from "Type/CarElement.type.hold";
import { useState } from "react";
import Styles from "Content/Equipment/EquipmentList.module.css";
import { Button } from "@mui/material";

type CreateEquipmentProps = {
    carUpdate: UpdateCarType;
    isOptional: boolean;
    addEquipment: Function;
};

export function CreateEquipment(props: CreateEquipmentProps) {
    const [input, setInput] = useState("");

    function handleAddEquipment() {
        if (input) {
            const customId =`new_Equipment_${Math.random()}`;
            props.addEquipment({
                id: customId,
                Name: input,
                Optionnal: props.isOptional,
                isNew: true,
            });
            if (!props.carUpdate.create.EquipmentsToCreate)
                props.carUpdate.create.EquipmentsToCreate = [];
            props.carUpdate.create.EquipmentsToCreate.push({id: customId, Name: input, Optionnal: props.isOptional});
            props.carUpdate.update.updated = true;
            setInput("");
        }
    };

    return (
        <div className={`${Styles.createEquipment}`}>
            <input className={`${Styles.equipmentInput}`} type="text" value={input} onChange={(e) => setInput(e.target.value)} />
            <Button size="small" variant="contained" onClick={handleAddEquipment}>{translator.decode("car.addEquipment")}</Button>
        </div>
    );
};
